export default {
  NEW_LINE: '\n',
  NON_BREAKING_SPACE: '\u00a0',
  NON_BREAKING_SPACE_GLOBAL_REGEX: new RegExp('\u00a0', 'g'),
  ZERO_WIDTH_SPACE: '\u200b',
  ZERO_WIDTH_SPACE_GLOBAL_REGEX: new RegExp('\u200b', 'g'),
  COPY_SAFE_HREF_ATTRIBUTE: 'data-url',
  COPY_SAFE_HREF_REGEX: /\s?data\-url=\\?"[^\\"]+\\?"/g,
  EMPTY_TEXT_HTML_REGEX: /^<(p|h1|h2) data-align="(left|center)"><\/(p|h1|h2)>$/,
  DECIMAL_ENCODED_SINGLE_QUOTE: '&#39;',
  DECIMAL_ENCODED_BACKTICK: '&#96;',
  DECIMAL_ENCODED_EQUALS: '&#61;',
  YOUTUBE_IFRAME_EMBED_URL_REGEX: /^https?:\/\/(?:www\.)?youtube\.com\/embed\/([\w|-]+)(?:\S+)?$/
};